export class TTLSet {
    defaultTTL;
    items;
    constructor(defaultTTL) {
        this.defaultTTL = defaultTTL;
        if (defaultTTL <= 0) {
            throw new Error('Default TTL must be a positive number.');
        }
        this.items = new Map();
        this.defaultTTL = defaultTTL;
        // Automatically remove expired items at intervals
        setInterval(() => this.cleanup(), defaultTTL);
    }
    // Adds an item to the set with an optional custom TTL
    add(item, ttl) {
        const effectiveTTL = ttl !== undefined ? ttl : this.defaultTTL;
        if (effectiveTTL <= 0) {
            throw new Error('TTL must be a positive number.');
        }
        const expireAt = Date.now() + effectiveTTL;
        this.items.set(item, expireAt);
    }
    // Checks if the item exists and has not expired
    has(item) {
        const expireAt = this.items.get(item);
        if (expireAt === undefined) {
            return false;
        }
        if (Date.now() > expireAt) {
            this.items.delete(item); // Remove expired item
            return false;
        }
        return true;
    }
    // Removes an item from the set
    delete(item) {
        this.items.delete(item);
    }
    // Returns the current size of the set, excluding expired items
    get size() {
        this.cleanup();
        return this.items.size;
    }
    // Clears all items from the set
    clear() {
        this.items.clear();
    }
    // Removes expired items
    cleanup() {
        const now = Date.now();
        for (const [item, expireAt] of this.items.entries()) {
            if (expireAt <= now) {
                this.items.delete(item);
            }
        }
    }
    // Returns all active items as an array
    toArray() {
        this.cleanup();
        return Array.from(this.items.keys());
    }
}
